import React from "react";
import  './page_2.css'
import { useTranslation } from 'react-i18next';
/*
import ownerPicture_2 from "/data/appData/appImages/owner/owner2.jpg" ;
import ownerPicture_3 from "/data/appData/appImages/owner/owner3.jpg" ;
import ownerPicture_4 from "/data/appData/appImages/owner/owner4.jpg" ;
import ownerPicture_5 from "/data/appData/appImages/owner/owner5.jpg" ;*/

function Page_2(){
    const { t } = useTranslation();
    return(
        <div className="page_2_content" >

            <div className="page_2_content_marge page_2_content_marge_resp">
                <img className="page_2_content_ownerPicture" src={"/data/appData/appImages/owner/owner2.jpg"} alt="" onContextMenu={(e)=> e.preventDefault()}></img> 
                <p className="page_2_content_bio_par">
            <span className="alTsDEco">{t("mister")} TADLAOUI Said</span>, {t("directorOfHaras")} <span className="alTsDEco">Al Ts Stud Morocco</span>, {t("aboutDirector1")}
            <br></br><br></br> {t("aboutDirector2")}
            
            </p>
            <img className="page_2_content_ownerPicture" src={"/data/appData/appImages/owner/owner3.jpg"} alt="" onContextMenu={(e)=> e.preventDefault()} ></img> 
            <p className="page_2_content_bio_par">
            <span className="alTsDEco">{t("mister")} TADLAOUI Said</span>, {t("aboutDirector3")}
            
            </p>
            <img className="page_2_content_ownerPicture" src={"/data/appData/appImages/owner/owner4.jpg"} alt="" onContextMenu={(e)=> e.preventDefault()} ></img> 


            <p className="page_2_content_bio_par">
            {t("aboutDirector4")}
            </p>


            <img className="page_2_content_ownerPicture" src={"/data/appData/appImages/owner/owner5.jpg"} alt="" onContextMenu={(e)=> e.preventDefault()} ></img> 


            </div>

           
            
        </div>
    )
}

export default Page_2